<div
  class="flex flex-1 flex-column px-6 h-100 w-100 justify-content-center"
  style="height: 100%"
  *ngIf="processing"
>
  <!-- <div class="flex justify-content-center mb-2">
   <img
      src="assets/images/logo.png"
      alt="Logo"
      style="max-width: 100%; max-height: 120px"
    />
  </div>  -->

  <div class="flex justify-content-center" style="height: 140px">
    <ng-lottie [options]="options"></ng-lottie>
  </div>
  <div class="flex justify-content-center">
    {{ "AUTH.LOADING" | translate }}
  </div>
</div>


<!-- <div #certificateRef id="certificate" class="flex flex-column align-items-center justify-content-center w-full p-5 bg-white border-round shadow-2 certificate-container">
  <img src="assets/images/logo.png" alt="Logo" class="mb-4" style="max-height: 80px;" />

  <h2 class="text-3xl font-bold mb-2 text-center">Certificado de Finalización</h2>
  <p class="text-xl mb-4 text-center">Este certificado se otorga a</p>

  <h1 class="text-4xl font-bold text-primary mb-4 text-center">{{row.user.first_name + ' '}} {{row.user.last_name}}</h1>

  <p class="text-lg text-center mb-4" style="max-width: 600px;">
    Por completar exitosamente el curso <strong>"{{row.course.name_}}"</strong> con una duración de {{row.course.estimated_duration}} horas.
  </p>

  <div class="flex justify-content-between w-full mt-5" style="max-width: 600px;">
    <div class="flex flex-column align-items-start">
      <span class="text-sm text-secondary">Fecha</span>
      <strong>{{row.enrollment_at}}</strong>
    </div>

  </div>
</div> -->


<div #certificateRef id="certificate" class="flex flex-column align-items-center justify-content-center w-full certificate-container">

</div>

<div class="flex gap-3 justify-content-center mt-5">
  <button pButton type="button" label="Descargar PDF" icon="pi pi-file-pdf" class="p-button-secondary" (click)="downloadPDF()"></button>
  <button pButton type="button" label="Descargar Imagen" icon="pi pi-image" class="p-button-success" (click)="downloadImage()"></button>
</div>
